import { debounce } from 'lodash';
import moment from 'moment-timezone';
import { useCallback, useEffect, useState } from 'react';
import { Spinner, Alert } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa6';
import Lightbox from 'react-image-lightbox';
import ReactReadMoreReadLess from "react-read-more-read-less";
import { Tooltip } from 'react-tooltip';
import { KTSVG } from '../../../../_metronic/helpers';
import CurrencyComp from '../../../../components/currencyComponent/CurrencyComp';
import DateComp from '../../../../components/dateComponent/DateComp';
import DateRangeComp from '../../../../components/dateComponent/DateRangeComp';
import { LoadingComponent } from '../../../../components/loadingComponent/LoadingComponent';
import NoRecordFound from '../../../../components/noRecord/NoRecordFound';
import Pagination from '../../../../components/pagination/Pagination';
import TableHeading from '../../../../components/tableHeading/TableHeading';
import TableSettingMenu from '../../../../components/tableHeading/TableSettingMenu';
import SearchSelect from '../../../../components/textFields/SearchSelect';
import TextField from '../../../../components/textFields/TextField';
import { constraintConfig } from '../../../../constraintConfig';
import { useGetAllBankAndUserLineItemsQuery, useGetAllBankLineItemsQuery, useGetAllLineItemsDraftByUserQuery } from '../../../../services/AutomationApi';
import { useGetAllUsersManagerAdminQuery } from '../../../../services/GeneralApi';
import { useGetVendorLookUpQuery } from '../../../../services/VendorApi';
import useColumnVisibility from '../../../customHooks/useColumnVisibility';
import labelKey from '../../../localization/label.json';
import MergeLineItemModal from './MergeLineItemModal';
import { IoIosRepeat } from 'react-icons/io';
import { toast } from 'react-toastify';
import { PageTitle } from '../../../../_metronic/layout/core';
import CreatePendingLineItemModal from './CreatePendingLineItemModal';

interface LightboxData {
    imageURL: string;
}
const MergeLineItems = () => {
    const currentDate = moment().format('MM/DD/YYYY');
    const last30Days = moment().subtract(29, 'days').format('MM/DD/YYYY');
    const { hiddenColumns, handleToggleColumn } = useColumnVisibility({ pageName: 'mergeLineItems' });

    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxData, setLightboxData] = useState<LightboxData>({ imageURL: '' });
    const [pageNumber, setPageNumber] = useState(1)
    const [pageSize, setPageSize] = useState(20);

    const [searchStr, setSearchStr] = useState('');
    const [immediateSearchStr, setImmediateSearchStr] = useState('');
    const [sortBy, setSortBy] = useState("ccItemImportDate");
    const [sortOrder, setSortOrder] = useState("desc");

    const [sortedColumn, setSortedColumn] = useState("ccItemImportDate");

    const [filterByStatus, setFilterByStatus] = useState(true);
    const [activeTab, setActiveTab] = useState(true);
    // const [isLoading, setIsLoading] = useState(false);
    const [filterByStartDate, setFilterByStartDate] = useState(last30Days);
    const [filterByEndDate, setFilterByEndDate] = useState(currentDate);
    const [localFilterByStartDate, setLocalFilterByStartDate] = useState(last30Days);
    const [localFilterByEndDate, setLocalFilterByEndDate] = useState(currentDate);
    const [filterByUserId, setFilterByUserId] = useState('');
    const [localFilterByUserId, setLocalFilterByUserId] = useState('');
    const [filterByVendor, setFilterByVendor] = useState("");
    const [localFilterByVendor, setLocalFilterByVendor] = useState("");

    // const [ssIsLoading, setSSIsLoading] = useState(false);

    const [ssPageNumber, setSSPageNumber] = useState(1)
    const [ssPageSize, setSSPageSize] = useState(20);
    const [ssSortBy, setSSSortBy] = useState("ccItemImportDate");
    const [ssSortOrder, setSSSortOrder] = useState("desc");
    const [ssSortedColumn, setSSSortedColumn] = useState("ccItemImportDate");
    const [ssFilterByStartDate, setSSFilterByStartDate] = useState(last30Days);
    const [ssFilterByEndDate, setSSFilterByEndDate] = useState(currentDate);
    const [ssLocalFilterByStartDate, setSSLocalFilterByStartDate] = useState(last30Days);
    const [ssLocalFilterByEndDate, setSSLocalFilterByEndDate] = useState(currentDate);
    const [ssFilterByVendor, setSSFilterByVendor] = useState("");
    const [ssLocalFilterByVendor, setSSLocalFilterByVendor] = useState("");

    const [isApplyingFilters, setIsApplyingFilters] = useState(false);
    // Debounced search state
    // const [searchStr, setSearchStr] = useState('');
    const { data: allsuersLookup } = useGetAllUsersManagerAdminQuery('')
    const { data: vendor } = useGetVendorLookUpQuery('')

    const { data, refetch, isFetching: isLoading, isSuccess } = useGetAllBankLineItemsQuery({
        orgUserId: filterByUserId,
        pageNumber: pageNumber,
        pageSize: pageSize,
        searchStr: searchStr,
        sortBy: sortBy,
        sortOrder: sortOrder,
        IslinkedItems: filterByStatus,
        startDate: filterByStartDate,
        endDate: filterByEndDate,
        vendorId: filterByVendor,

    })
    const { data: ssLineItemData, isFetching: ssIsLoading, refetch: ssLineItemRefetch, isSuccess: ssLineItemIsSuccess } = useGetAllLineItemsDraftByUserQuery({
        orgUserId: filterByUserId,
        pageNumber: ssPageNumber,
        pageSize: ssPageSize,
        searchStr: searchStr,
        sortBy: ssSortBy,
        sortOrder: ssSortOrder,
        IslinkedItems: filterByStatus,
        startDate: ssFilterByStartDate,
        endDate: ssFilterByEndDate,
        vendorId: ssFilterByVendor,

    })
    useEffect(() => {
        refetch()
    }, [filterByStatus, pageNumber, pageSize, refetch]);
    useEffect(() => {
        ssLineItemRefetch()
    }, [ssPageNumber, ssPageSize, ssLineItemRefetch]);

    const handlePageSizeChange = (e: any) => {
        const newSize = parseInt(e.target.value);
        setPageSize(newSize);
        setPageNumber(1); // Reset page number to 1
    };
    // pagination
    const handlePageClick = (e: any) => {
        setPageNumber(e.selected + 1);
    };
    //per page record
    const handlePageRecords = (e: any) => {
        setPageNumber(1); // Reset the page to 1
    };
    const handleSort = (property: string) => {
        setSortBy(property);
        if (sortedColumn === property) {
            setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
        } else {
            setSortedColumn(property);
            setSortOrder("asc");
        }
    };

    const handleSSPageSizeChange = (e: any) => {
        const newSize = parseInt(e.target.value);
        setSSPageSize(newSize);
        setSSPageNumber(1); // Reset page number to 1
    };
    // pagination
    const handleSSPageClick = (e: any) => {
        setSSPageNumber(e.selected + 1);
    };
    //per page record
    const handleSSPageRecords = (e: any) => {
        setSSPageNumber(1); // Reset the page to 1
    };
    const handleSSSort = (property: string) => {
        setSSSortBy(property);
        if (ssSortedColumn === property) {
            setSSSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
        } else {
            setSSSortedColumn(property);
            setSSSortOrder("asc");
        }
    };


    const handleSearchChange = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr(value); // Update immediate search state

        delayedSearch(value); // Update debounced search state
    };

    const handleUserChange = (e: any) => {
        setLocalFilterByUserId(e.value);
    };
    const handleDateRangeChange = (event: any, picker: any) => {
        const startDateFormatted = moment(picker.startDate).format('MM-DD-YYYY');
        const endDateFormatted = moment(picker.endDate).format('MM-DD-YYYY');

        setLocalFilterByStartDate(startDateFormatted);
        setLocalFilterByEndDate(endDateFormatted);

    };
    const handleSSDateRangeChange = (event: any, picker: any) => {
        const startDateFormatted = moment(picker.startDate).format('MM-DD-YYYY');
        const endDateFormatted = moment(picker.endDate).format('MM-DD-YYYY');

        setSSLocalFilterByStartDate(startDateFormatted);
        setSSLocalFilterByEndDate(endDateFormatted);

    };
    const handleCancelDateSelection = (event: any, picker: any) => {
        // Reset the state to empty strings
        setFilterByStartDate(last30Days);
        setFilterByEndDate(currentDate);
        setLocalFilterByStartDate(last30Days);
        setLocalFilterByEndDate(currentDate);
    };
    const handleSSCancelDateSelection = (event: any, picker: any) => {
        // Reset the state to empty strings
        setSSFilterByStartDate(last30Days);
        setSSFilterByEndDate(currentDate);
        setSSLocalFilterByStartDate(last30Days);
        setSSLocalFilterByEndDate(currentDate);
    };
    const handleVendorChange = (e: any) => {
        setLocalFilterByVendor(e.value);
    };
    const handleSSVendorChange = (e: any) => {
        setSSLocalFilterByVendor(e.value);
    };
    const applyFilters = () => {
        setIsApplyingFilters(true);
        setFilterByStartDate(localFilterByStartDate);
        setFilterByEndDate(localFilterByEndDate);
        setFilterByUserId(localFilterByUserId)
        setFilterByVendor(localFilterByVendor)
        setSSFilterByStartDate(ssLocalFilterByStartDate);
        setSSFilterByEndDate(ssLocalFilterByEndDate);
        setSSFilterByVendor(ssLocalFilterByVendor);
        setPageNumber(1);
        setSSPageNumber(1);
    };
    const resetFilters = () => {
        setFilterByStartDate(last30Days);
        setFilterByEndDate(currentDate);
        setFilterByUserId('')
        setFilterByVendor('')
        setSSFilterByStartDate(last30Days);
        setSSFilterByEndDate(currentDate);
        setSSFilterByVendor('')


        setLocalFilterByStartDate(last30Days);
        setLocalFilterByEndDate(currentDate);
        setLocalFilterByUserId('')
        setLocalFilterByVendor('')
        setSSLocalFilterByVendor('')
        setSSLocalFilterByStartDate(last30Days);
        setSSLocalFilterByEndDate(currentDate);

    }

    const delayedSearch = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
        }, 500),
        []
    );

    const debouncedRefetch = debounce(() => {
        refetch().finally(() => {
            setIsApplyingFilters(false);
        });
        ssLineItemRefetch().finally(() => {
            setIsApplyingFilters(false);
        });
    }, 300);
    useEffect(() => {
        if (isApplyingFilters) {
            debouncedRefetch();
        }
    }, [isApplyingFilters]);

    useEffect(() => {
        if (searchStr !== "" && sortOrder !== "" && sortBy !== "") {
            refetch();
        }
    }, [searchStr, sortOrder, sortBy, refetch]);
    useEffect(() => {
        if (ssSortOrder !== "" && ssSortBy !== "") {
            ssLineItemRefetch();
        }
    }, [ssSortOrder, ssSortBy, ssLineItemRefetch]);

    const handleTabChange = (status: boolean) => {
        setActiveTab(status);
        setFilterByStatus(status);
        setTimeout(() => {
            refetch();
        }, 200);
        setPageNumber(1)
        setPageSize(20)
        setSSPageNumber(1)
        setSSPageSize(20)
    };

    const [selectedBankData, setSelectedBankData] = useState(null);
    const [selectedDraftData, setSelectedDraftData] = useState(null);
    const [selectePendingLineItemData, setSelectedPendingLineItemData] = useState(null);

    // Handle radio button selection
    const handleBankDataRadioSelect = (bankData: any) => {
        setSelectedBankData(bankData);
    };
    const handlePendingLineItemRadioSelect = (bankData: any) => {
        setSelectedPendingLineItemData(bankData);
    };

    const handleDraftDataRadioSelect = (DraftData: any) => {
        setSelectedDraftData(DraftData);
    };


    const [showMergeLineItemModal, setShowMergeLineItemModal] = useState(false)
    const [showCreatePendingLineItemModal, setShowCreatePendingLineItemModal] = useState(false)


    const mergeLineItemHandler = () => {
        setShowMergeLineItemModal((prev) => !prev);
    };
    const createPendingLineItemHandler = () => {
        setShowCreatePendingLineItemModal((prev) => !prev);
    };

    useEffect(() => {
        if (showMergeLineItemModal === false) {
            setSelectedBankData(null)
            setSelectedDraftData(null)
            ssLineItemRefetch()
            refetch()
        }
    }, [showMergeLineItemModal])

    const isPdfFile = (filePath: string | undefined) => {
        if (!filePath) return false;
        const fileExtension = filePath.toLowerCase().split('.').pop();
        return fileExtension === 'pdf';
    };
    const openPdfInBrowserOrLightbox = (attachmentFile: string | undefined) => {
        if (attachmentFile) {
            if (isPdfFile(attachmentFile)) {
                // For PDF files, open in the browser
                window.open(attachmentFile, '_blank');
            } else {
                // For image files, open in the Lightbox
                setLightboxData({ imageURL: attachmentFile });
                setLightboxOpen(true);
            }
        }
    };


    const handleRefresh = () => {
        // Set the state values
        // setFilterByStartDate(last30Days);
        // setFilterByEndDate(currentDate);
        // setLocalFilterByStartDate(last30Days);
        // setLocalFilterByEndDate(currentDate);
        // setLocalFilterByStartDate(last30Days);
        // setLocalFilterByEndDate(currentDate);
        // setSSLocalFilterByStartDate(last30Days);
        // setSSLocalFilterByEndDate(currentDate);
        // Trigger refetch after state updates are done

        Promise.all([ssLineItemRefetch(), refetch()])
            .then(([ssLineItemResult, refetchResult]) => {
                // Assuming you use isSuccess from both results to check if the refetch was successful
                const isSSLineItemSuccess = ssLineItemResult.isSuccess;
                const isRefetchSuccess = refetchResult.isSuccess;

                if (isSSLineItemSuccess || isRefetchSuccess) {
                    toast.success('Data Refreshed successfully!');
                }
            })
    };

    return (
        <>
            <MergeLineItemModal
                show={showMergeLineItemModal}
                handleClose={() => setShowMergeLineItemModal(false)}
                selectedBankData={selectedBankData}
                selectedDraftData={selectedDraftData}
                refetch={refetch} />
            <CreatePendingLineItemModal
                show={showCreatePendingLineItemModal}
                handleClose={() => setShowCreatePendingLineItemModal(false)}
                selectePendingLineItemData={selectePendingLineItemData}
                refetch={refetch} />
            {lightboxOpen && (
                <Lightbox
                    mainSrc={lightboxData.imageURL}
                    onCloseRequest={() => setLightboxOpen(false)}
                    imageCaption="Attachment"
                    enableZoom={true}
                    imagePadding={50}
                />
            )}
            <Tooltip id="refreshData" place="top" />
            <PageTitle breadcrumbs={[]}>Merge BC - SS LineItems</PageTitle>

            <div className='card mb-5'>
                <div className="col-12">
                    <Alert variant="primary" className="m-2">
                        <p className='fs-6 mt-3'>Displays bank-imported Corporate Credit Card (CC Feed) transactions and SpendSail Line Items side by side. This page allows the admin to identify matching records, review transaction details, and merge them into a single expense to ensure accurate reconciliation and eliminate duplicate entries.</p>
                    </Alert>
                </div>
                <div className='card-header border-0 pb-0'>
                    <div className='d-flex align-items-center justify-content-between w-100'>
                        <div className='d-flex align-items-cenetr gap-2'>
                            <div className='btn-group overflow-auto' style={{ minWidth: "max-content" }}>
                                <button
                                    type='button'
                                    className={`btn btn-sm ${activeTab === true ? 'btn-primary' : 'btn-light-primary'}`}
                                    onClick={() => handleTabChange(true)}
                                >
                                    {labelKey.lineItems}
                                </button>
                                <button
                                    type='button'
                                    className={`btn btn-sm ${activeTab === false ? 'btn-primary' : 'btn-light-primary'}`}
                                    onClick={() => handleTabChange(false)}
                                >
                                    {labelKey.lineItemsPending}
                                </button>
                            </div>
                            <div
                                data-tooltip-id="refreshData" data-tooltip-content='Refresh Data'
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-2' onClick={handleRefresh}>
                                <IoIosRepeat className='h-20px w-20px' />
                            </div>
                        </div>
                        {/* <SearchBarComponent
                            placeholder='User Name'
                            value={immediateSearchStr}
                            onChange={handleSearchChange} // Use immediate search handler
                        /> */}
                        {activeTab === true &&
                            <button className='btn btn-sm btn-light-primary'
                                onClick={() => mergeLineItemHandler()}
                                disabled={!selectedBankData || !selectedDraftData}
                            >
                                {labelKey.mergeLineItem}
                            </button>
                        }
                    </div>
                </div>
                <div className='card-body py-8 pt-0'>
                    <div className="row align-items-end mb-5">
                        <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                            <SearchSelect
                                label={`${labelKey.user}:`}
                                required
                                options={[
                                    { value: '', label: 'Select User' }, // Add the empty option
                                    ...(Array.isArray(allsuersLookup?.result) ? allsuersLookup.result.map((option: any) => ({
                                        value: option.id,
                                        label: option?.value,
                                    })) : [])
                                ]}
                                placeholder={labelKey.selectUser}
                                value={localFilterByUserId && localFilterByUserId !== ''
                                    ? {
                                        value: localFilterByUserId,
                                        label: allsuersLookup?.result.find((option: any) => option.id === localFilterByUserId)?.value
                                    }
                                    : null
                                }
                                onChange={handleUserChange}
                            />
                        </div>

                        <div className='col-md-8 col-lg-9 col-xl-10 mb-5'>
                            <div className='d-flex align-items-end h-100 gap-3'>
                                <button className='btn btn-danger pull-right me-3 ms-auto' onClick={resetFilters}>Reset Filters</button>

                                <button className='btn btn-primary pull-right' onClick={applyFilters}>
                                    {isApplyingFilters ? <>
                                        <span>loading...</span>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                    </> : "Apply Filters"}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className={`${activeTab === true ? "col-md-6" : "col-md-12"}`}>
                            <h3 className="card-title">Corporate Credit Card LineItems</h3>
                            <div className="row align-items-end">
                                <div className='col-md-6 col-lg-6 col-xl-4 mb-5'>
                                    <DateRangeComp
                                        required
                                        startDate={localFilterByStartDate || moment()}
                                        endDate={localFilterByEndDate || moment()}
                                        onApply={handleDateRangeChange} onCancel={handleCancelDateSelection}
                                        value={localFilterByStartDate && localFilterByEndDate ? `${localFilterByStartDate} - ${localFilterByEndDate}` : "MM/DD/YYYY"} />
                                </div>
                                <div className='col-md-6 col-lg-6 col-xl-4 mb-5'>
                                    <SearchSelect
                                        label={`${labelKey.vendor}:`}
                                        options={[
                                            { value: '', label: 'Select Vendor' }, // Add the empty option
                                            ...(Array.isArray(vendor?.result) ? vendor.result.map((option: any) => ({
                                                value: option.id,
                                                label: option?.value,
                                            })) : [])
                                        ]}
                                        placeholder={labelKey.selectVendor}
                                        value={localFilterByVendor && localFilterByVendor !== ''
                                            ? {
                                                value: localFilterByVendor,
                                                label: vendor?.result.find((option: any) => option.id === localFilterByVendor)?.value
                                            }
                                            : null
                                        }
                                        onChange={handleVendorChange}
                                    />
                                </div>
                                {activeTab !== true &&
                                    <div className='col-md-6 col-lg-6 col-xl-4 mb-5'>
                                        <button className='btn btn-sm btn-light-primary'
                                            onClick={() => createPendingLineItemHandler()}
                                            disabled={!selectePendingLineItemData}
                                        >
                                            {labelKey.createPendingLineItem}
                                        </button>
                                    </div>
                                }
                            </div>
                            <div className='table-responsive table-height'>
                                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                                    <thead>
                                        <tr className='fw-bold text-muted'>

                                            <>

                                                {/* {activeTab === true && */}
                                                <th></th>
                                                {/* } */}
                                                {hiddenColumns.includes('cCTransactionID') && (
                                                    <TableHeading
                                                        label={labelKey.cCTransactionID}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='cCTransactionID'
                                                        className="ps-4"
                                                    />
                                                )}

                                                {hiddenColumns.includes('accountNumber') && (
                                                    <TableHeading
                                                        label={labelKey.accountNumber}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='accountNumber'
                                                        className="ps-4"
                                                    />
                                                )}
                                                {hiddenColumns.includes('merchantType') && (
                                                    <TableHeading
                                                        label={labelKey.merchantType}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='merchantType'
                                                        className="ps-4"
                                                    />
                                                )}

                                                {hiddenColumns.includes('cctransactionDate') && (
                                                    <TableHeading
                                                        label={labelKey.itemDate}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='cctransactionDate'
                                                        className="w-100px text-end"
                                                    />
                                                )}
                                                {hiddenColumns.includes('ccCategory') && (
                                                    <TableHeading
                                                        label={labelKey.category}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='ccCategory'
                                                    />
                                                )}
                                                {hiddenColumns.includes('debitOrCreditIndicator') && (
                                                    <TableHeading
                                                        label={labelKey.debitOrCreditIndicator}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='debitOrCreditIndicator'
                                                        className="w-100px text-end"
                                                    />
                                                )}
                                                {hiddenColumns.includes('ccTotalAmount') && (
                                                    <TableHeading
                                                        label={labelKey.ccTotalAmount}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='ccTotalAmount pe-4'
                                                        className="w-100px"
                                                    />
                                                )}
                                                {/* {hiddenColumns.includes('ccMerchantType') && (
                                                    <TableHeading
                                                        label={labelKey.merchantType}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='ccMerchantType'
                                                        className="ps-4"
                                                    />
                                                )} */}

                                                {hiddenColumns.includes('ccVendorName') && (
                                                    <TableHeading
                                                        label={labelKey.vendor}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='ccVendorName'
                                                    />
                                                )}
                                                {hiddenColumns.includes('ccAttachement') && (
                                                    <TableHeading
                                                        label={labelKey.attachment}
                                                        // sortedColumn={sortedColumn}
                                                        // sortOrder={sortOrder}
                                                        // handleSort={handleSort}
                                                        columnId='ccAttachement'
                                                        className="pe-4"
                                                    />
                                                )}
                                                {hiddenColumns.includes('ccReportId') && (
                                                    <TableHeading
                                                        label={labelKey.reportId}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='ccReportId'
                                                        className="pe-4"
                                                    />
                                                )}
                                                {hiddenColumns.includes('ccPyamentMethod') && (
                                                    <TableHeading
                                                        label={labelKey.paymentMethod}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='ccPyamentMethod'
                                                        className="pe-4"
                                                    />
                                                )}
                                                {hiddenColumns.includes('ccItemDescription') && (
                                                    <TableHeading
                                                        label={labelKey.itemDescription}
                                                        // sortedColumn={sortedColumn}
                                                        // sortOrder={sortOrder}
                                                        // handleSort={handleSort}
                                                        columnId='ccItemDescription'
                                                    />
                                                )}
                                                {hiddenColumns.includes('ccItemImportDate') && (
                                                    <TableHeading
                                                        label={labelKey.createdDate}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='ccItemImportDate'
                                                        className="w-100px text-end pe-15"
                                                    />
                                                )}
                                                {hiddenColumns.includes('ccLineItemId') && (
                                                    <TableHeading
                                                        label={labelKey.ssLineItemId}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='ccLineItemId'
                                                        className="w-100px text-end pe-15"
                                                    />
                                                )}
                                                {hiddenColumns.includes('ccSource') && (
                                                    <TableHeading
                                                        label={labelKey.source}
                                                        // sortedColumn={sortedColumn}
                                                        // sortOrder={sortOrder}
                                                        // handleSort={handleSort}
                                                        columnId='ccSource'
                                                        className="w-100px text-end pe-15"
                                                    />
                                                )}
                                                <th className='text-end rounded-end pe-2 border-0'>
                                                    <TableSettingMenu tooltipContent={false}>
                                                        <TextField
                                                            rightLabel={labelKey.cCTransactionID}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("cCTransactionID")}
                                                            checked={hiddenColumns.includes('cCTransactionID')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.merchantType}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("merchantType")}
                                                            checked={hiddenColumns.includes('merchantType')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.accountNumber}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("accountNumber")}
                                                            checked={hiddenColumns.includes('accountNumber')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.itemDate}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("cctransactionDate")}
                                                            checked={hiddenColumns.includes('cctransactionDate')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.debitOrCreditIndicator}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ccCategory")}
                                                            checked={hiddenColumns.includes('ccCategory')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.category}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("debitOrCreditIndicator")}
                                                            checked={hiddenColumns.includes('debitOrCreditIndicator')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.itemAmount}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ccTotalAmount")}
                                                            checked={hiddenColumns.includes('ccTotalAmount')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.vendor}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ccVendorName")}
                                                            checked={hiddenColumns.includes('ccVendorName')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.attachment}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ccAttachement")}
                                                            checked={hiddenColumns.includes('ccAttachement')}
                                                            fieldClass='mb-4'
                                                        />

                                                        <TextField
                                                            rightLabel={labelKey.reportId}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ccReportId")}
                                                            checked={hiddenColumns.includes('ccReportId')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.paymentMethod}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ccPyamentMethod")}
                                                            checked={hiddenColumns.includes('ccPyamentMethod')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.itemDescription}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ccItemDescription")}
                                                            checked={hiddenColumns.includes('ccItemDescription')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.createdDate}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ccItemImportDate")}
                                                            checked={hiddenColumns.includes('ccItemImportDate')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.ccLineItemId}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ccLineItemId")}
                                                            checked={hiddenColumns.includes('ccLineItemId')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.source}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ccSource")}
                                                            checked={hiddenColumns.includes('ccSource')}
                                                            fieldClass='mb-4'
                                                        />
                                                    </TableSettingMenu>
                                                </th>

                                            </>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {!isLoading &&
                                            <>
                                                {data?.result?.data?.length > 0 ? (
                                                    <>
                                                        {data?.result?.data?.map((data: any, index: any) => (
                                                            <tr key={index}>

                                                                <td className='ps-4'>
                                                                    <div className='form-check form-check-sm form-check-custom form-check-solid me-3'>
                                                                        {activeTab === true ?
                                                                            <input type="radio" className='form-check-input'
                                                                                checked={selectedBankData === data}
                                                                                name='bankData'
                                                                                onChange={() => handleBankDataRadioSelect(data)}
                                                                            //  checked={selectedTransactionId === item.financialTransactionEntityId}
                                                                            />
                                                                            :
                                                                            <input type="radio" className='form-check-input'
                                                                                checked={selectePendingLineItemData === data}
                                                                                name='bankData'
                                                                                onChange={() => handlePendingLineItemRadioSelect(data)}
                                                                            //  checked={selectedTransactionId === item.financialTransactionEntityId}
                                                                            />
                                                                        }
                                                                    </div>
                                                                </td>
                                                                {hiddenColumns.includes('cCTransactionID') && (
                                                                    <td className='ps-4'>{data?.processorTransactionId ? data?.processorTransactionId : "N/A"}</td>
                                                                )}
                                                                {hiddenColumns.includes('accountNumber') && (
                                                                    <td>{data?.accountNumber ? data?.accountNumber : "N/A"}</td>
                                                                )}
                                                                {hiddenColumns.includes('merchantType') && (
                                                                    <td>{data?.merchantType ? data?.merchantType : "N/A"}</td>
                                                                )}
                                                                {hiddenColumns.includes('cctransactionDate') && (
                                                                    <td className='text-end'><DateComp formattedDate={data?.transactionDate} /></td>
                                                                )}
                                                                {hiddenColumns.includes('ccCategory') && (
                                                                    <td>{data?.expenseCategory?.title}</td>
                                                                )}
                                                                {hiddenColumns.includes('debitOrCreditIndicator') && (
                                                                    <td className={`text-center ${data?.debitOrCreditIndicator === constraintConfig.debitOrCreditIndicator.creditIndicator ? 'text-danger' : null}`}>{data?.debitOrCreditIndicator}</td>
                                                                )}
                                                                {hiddenColumns.includes('ccTotalAmount') && (
                                                                    <td className={`text-end pe-4 ${data?.debitOrCreditIndicator === constraintConfig.debitOrCreditIndicator.creditIndicator ? 'text-danger' : null}`}>
                                                                        <CurrencyComp amount={data?.ccTotalAmount} />
                                                                    </td>
                                                                )}
                                                                {/* {hiddenColumns.includes('ccMerchantType') && (
                                                                    <td>{data?.merchantType ? data?.merchantType : "N/A"}</td>
                                                                )} */}

                                                                {hiddenColumns.includes('ccVendorName') && (
                                                                    <td>{data?.vendor?.name}</td>
                                                                )}
                                                                {hiddenColumns.includes('ccAttachement') && (
                                                                    <td>
                                                                        {data?.attachmentFile === null || data?.attachmentFile === "null" || data?.attachmentFile === "undefined" || data?.attachmentFile === "" ? (
                                                                            null
                                                                        ) : <FaEye className='ms-10' onClick={() => openPdfInBrowserOrLightbox(data?.attachmentFile)} />}
                                                                    </td>
                                                                )}
                                                                {hiddenColumns.includes('ccReportId') && (
                                                                    <td>{data?.expenseReportId}</td>
                                                                )}
                                                                {hiddenColumns.includes('ccPyamentMethod') && (
                                                                    <td>{data?.expensePaymentMethod?.title}</td>
                                                                )}
                                                                {hiddenColumns.includes('ccItemDescription') && (
                                                                    <td>
                                                                        <div className='w-200px text-wrap'>
                                                                            {data && data.ccItemDescription && <ReactReadMoreReadLess
                                                                                charLimit={30}
                                                                                readMoreText={"Read more"}
                                                                                readLessText={"Read less"}
                                                                                readMoreClassName="readMore"
                                                                                readLessClassName="readLess"
                                                                            >
                                                                                {data.ccItemDescription}
                                                                            </ReactReadMoreReadLess>}
                                                                        </div>
                                                                    </td>
                                                                )}
                                                                {hiddenColumns.includes('ccItemImportDate') && (
                                                                    <td><DateComp formattedDate={data?.itemImportDate} /> </td>
                                                                )}

                                                                {hiddenColumns.includes('ccLineItemId') && (
                                                                    <td>{data?.ccLineItemId} </td>
                                                                )}

                                                                {hiddenColumns.includes('ccSource') && (
                                                                    <td className='ps-5'>
                                                                        <Tooltip id="web-source" place="top" />
                                                                        <Tooltip id="mobile-source" place="top" />
                                                                        <Tooltip id="bank-source" place="top" />
                                                                        <Tooltip id="gorilla-source" place="top" />

                                                                        {data?.recordSourceId === constraintConfig.recordSourceId.WebApp ?
                                                                            <KTSVG path="/media/icons/figmaIcons/Web.svg" className='svg-icon-1 ms-4'
                                                                                data-tooltip-id="web-source" data-tooltip-content='Website' />
                                                                            :
                                                                            data?.recordSourceId === constraintConfig.recordSourceId.Mobile ?
                                                                                <KTSVG path="/media/icons/figmaIcons/Mobile.svg" className='svg-icon-1 ms-4'
                                                                                    data-tooltip-id="mobile-source" data-tooltip-content='Mobile' /> :
                                                                                data?.recordSourceId === constraintConfig.recordSourceId.BankFeed ?
                                                                                    <KTSVG path="/media/icons/figmaIcons/Bank.svg" className='svg-icon-1 ms-4'
                                                                                        data-tooltip-id="bank-source" data-tooltip-content='Bank' />
                                                                                    : data?.recordSourceId === constraintConfig.recordSourceId.GorillaExpense ?
                                                                                        <KTSVG path="/media/icons/figmaIcons/Gorilla.svg" className='svg-icon-1 ms-4'
                                                                                            data-tooltip-id="gorilla-source" data-tooltip-content='Gorilla Expense' /> : null}
                                                                    </td>
                                                                )}
                                                            </tr>
                                                        ))}
                                                    </>) : (
                                                    <tr>
                                                        <td colSpan={20}>
                                                            <NoRecordFound />
                                                        </td>
                                                    </tr>
                                                )}
                                            </>}
                                        {isLoading && (
                                            <tr>
                                                <td colSpan={20} className="text-center">
                                                    <LoadingComponent />
                                                </td>
                                            </tr>
                                        )}

                                    </tbody>
                                </table>
                            </div>
                            <Pagination
                                totalResult={data?.result?.totalRecords === 0 ? 0 : ((data?.result?.pageNumber - 1) * data?.result?.pageSize) + 1}
                                toResult={data?.result?.totalRecords === 0 ? 0 : Math.min(data?.result?.pageNumber * data?.result?.pageSize, data?.result?.totalRecords)}
                                ofResult={data?.result?.totalRecords}
                                onChange={handlePageSizeChange}
                                pageSize={pageSize}
                                onPageChange={handlePageClick}
                                pageCount={data?.result?.totalPages || 0}
                                currentPage={pageNumber}

                            />
                        </div>
                        {activeTab === true &&
                            <div className="col-md-6">
                                <h3 className="card-title">SpendSail LineItems</h3>
                                <div className="row">
                                    <div className='col-md-6 col-lg-6 col-xl-4 mb-5'>
                                        <DateRangeComp
                                            required
                                            startDate={ssLocalFilterByStartDate || moment()}
                                            endDate={ssLocalFilterByEndDate || moment()}
                                            onApply={handleSSDateRangeChange} onCancel={handleSSCancelDateSelection}
                                            value={ssLocalFilterByStartDate && ssLocalFilterByEndDate ? `${ssLocalFilterByStartDate} - ${ssLocalFilterByEndDate}` : "MM/DD/YYYY"} />
                                    </div>
                                    <div className='col-md-6 col-lg-6 col-xl-4 mb-5'>
                                        <SearchSelect
                                            label={`${labelKey.vendor}:`}
                                            options={[
                                                { value: '', label: 'Select Vendor' }, // Add the empty option
                                                ...(Array.isArray(vendor?.result) ? vendor.result.map((option: any) => ({
                                                    value: option.id,
                                                    label: option?.value,
                                                })) : [])
                                            ]}
                                            placeholder={labelKey.selectVendor}
                                            value={ssLocalFilterByVendor && ssLocalFilterByVendor !== ''
                                                ? {
                                                    value: ssLocalFilterByVendor,
                                                    label: vendor?.result.find((option: any) => option.id === ssLocalFilterByVendor)?.value
                                                }
                                                : null
                                            }
                                            onChange={handleSSVendorChange}
                                        />
                                    </div>
                                </div>
                                <div className='table-responsive table-height'>
                                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                                        <thead>
                                            <tr className='fw-bold text-muted'>
                                                <>
                                                    <th></th>
                                                    {hiddenColumns.includes('ssItemDate') && (
                                                        <TableHeading
                                                            label={labelKey.itemDate}
                                                            sortedColumn={ssSortedColumn}
                                                            sortOrder={ssSortOrder}
                                                            handleSort={handleSSSort}
                                                            columnId='ssItemDate'
                                                            labelClassName="text-primary"
                                                        />
                                                    )}
                                                    {hiddenColumns.includes('ssExpenseCategoryName') && (
                                                        <TableHeading
                                                            label={labelKey.category}
                                                            sortedColumn={ssSortedColumn}
                                                            sortOrder={ssSortOrder}
                                                            handleSort={handleSSSort}
                                                            columnId='ssExpenseCategoryName'
                                                            labelClassName="text-primary"
                                                        />
                                                    )}
                                                    {hiddenColumns.includes('ssItemAmount') && (
                                                        <TableHeading
                                                            label={labelKey.itemAmount}
                                                            sortedColumn={ssSortedColumn}
                                                            sortOrder={ssSortOrder}
                                                            handleSort={handleSSSort}
                                                            columnId='ssItemAmount'
                                                            className="pe-4 w-100px"
                                                            labelClassName="justify-content-end text-primary"
                                                        />
                                                    )}

                                                    {hiddenColumns.includes('ssVendorName') && (
                                                        <TableHeading
                                                            label={labelKey.vendor}
                                                            sortedColumn={ssSortedColumn}
                                                            sortOrder={ssSortOrder}
                                                            handleSort={handleSSSort}
                                                            columnId='ssVendorName'
                                                            labelClassName="text-primary"
                                                        />
                                                    )}
                                                    {hiddenColumns.includes('ssAttachment') && (
                                                        <TableHeading
                                                            label={labelKey.attachment}
                                                            // sortedColumn={ssSortedColumn}
                                                            // sortOrder={ssSortOrder}
                                                            // handleSort={handleSSSort}
                                                            columnId='ssAttachment'
                                                            className="pe-4"
                                                            labelClassName="justify-content-end text-primary"
                                                        />
                                                    )}
                                                    {hiddenColumns.includes('ssReportId') && (
                                                        <TableHeading
                                                            label={labelKey.reportId}
                                                            sortedColumn={ssSortedColumn}
                                                            sortOrder={ssSortOrder}
                                                            handleSort={handleSSSort}
                                                            columnId='ssReportId'
                                                            className="pe-4"
                                                            labelClassName="justify-content-end text-primary"
                                                        />
                                                    )}
                                                    {hiddenColumns.includes('ssPaymentMethod') && (
                                                        <TableHeading
                                                            label={labelKey.paymentMethod}
                                                            sortedColumn={ssSortedColumn}
                                                            sortOrder={ssSortOrder}
                                                            handleSort={handleSSSort}
                                                            columnId='ssPaymentMethod'
                                                            className="pe-4"
                                                            labelClassName="text-primary"
                                                        />
                                                    )}
                                                    {hiddenColumns.includes('ssItemDescription') && (
                                                        <TableHeading
                                                            label={labelKey.itemDescription}
                                                            // sortedColumn={ssSortedColumn}
                                                            // sortOrder={ssSortOrder}
                                                            // handleSort={handleSSSort}
                                                            columnId='ssItemDescription'
                                                            labelClassName="text-primary"
                                                        />
                                                    )}
                                                    {hiddenColumns.includes('ssCreatedDate') && (
                                                        <TableHeading
                                                            label={labelKey.createdDate}
                                                            sortedColumn={ssSortedColumn}
                                                            sortOrder={ssSortOrder}
                                                            handleSort={handleSSSort}
                                                            columnId='ssCreatedDate'
                                                            className="w-100px text-end pe-15"
                                                            labelClassName="text-primary"
                                                        />
                                                    )}
                                                    {hiddenColumns.includes('ssLineItemId') && (
                                                        <TableHeading
                                                            label={labelKey.ssLineItemId}
                                                            sortedColumn={ssSortedColumn}
                                                            sortOrder={ssSortOrder}
                                                            handleSort={handleSSSort}
                                                            columnId='ssLineItemId'
                                                            className="w-100px text-end pe-15"
                                                            labelClassName="text-primary"
                                                        />
                                                    )}
                                                    {hiddenColumns.includes('ssSource') && (
                                                        <TableHeading
                                                            label={labelKey.source}
                                                            // sortedColumn={ssSortedColumn}
                                                            // sortOrder={ssSortOrder}
                                                            // handleSort={handleSSSort}
                                                            columnId='ssSource'
                                                            className="w-100px text-end pe-15"
                                                            labelClassName="text-primary"
                                                        />
                                                    )}
                                                </>
                                                <th className='text-end rounded-end pe-2 border-0'>
                                                    <TableSettingMenu tooltipContent={false}>
                                                        <TextField
                                                            rightLabel={labelKey.itemDate}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ssItemDate")}
                                                            checked={hiddenColumns.includes('ssItemDate')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.category}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ssExpenseCategoryName")}
                                                            checked={hiddenColumns.includes('ssExpenseCategoryName')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.itemAmount}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ssItemAmount")}
                                                            checked={hiddenColumns.includes('ssItemAmount')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.vendor}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ssVendorName")}
                                                            checked={hiddenColumns.includes('ssVendorName')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.attachment}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ssAttachment")}
                                                            checked={hiddenColumns.includes('ssAttachment')}
                                                            fieldClass='mb-4'
                                                        />

                                                        <TextField
                                                            rightLabel={labelKey.reportId}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ssReportId")}
                                                            checked={hiddenColumns.includes('ssReportId')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.paymentMethod}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ssPaymentMethod")}
                                                            checked={hiddenColumns.includes('ssPaymentMethod')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.itemDescription}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ssItemDescription")}
                                                            checked={hiddenColumns.includes('ssItemDescription')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.createdDate}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ssCreatedDate")}
                                                            checked={hiddenColumns.includes('ssCreatedDate')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.ssLineItemId}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ssLineItemId")}
                                                            checked={hiddenColumns.includes('ssLineItemId')}
                                                            fieldClass='mb-4'
                                                        />
                                                        <TextField
                                                            rightLabel={labelKey.source}
                                                            type="checkbox"
                                                            onChange={() => handleToggleColumn("ssSource")}
                                                            checked={hiddenColumns.includes('ssSource')}
                                                            fieldClass='mb-4'
                                                        />
                                                    </TableSettingMenu>
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {!ssIsLoading &&
                                                <>
                                                    {ssLineItemData?.result?.data?.length > 0 ? (
                                                        <>
                                                            {ssLineItemData?.result?.data?.map((data: any, index: any) => (
                                                                <tr key={index}>
                                                                    <>
                                                                        <td className='ps-4'>
                                                                            <div className='form-check form-check-sm form-check-custom form-check-solid me-3'>
                                                                                <input type="radio"
                                                                                    className='form-check-input'
                                                                                    name='draftData'
                                                                                    checked={selectedDraftData === data}
                                                                                    onChange={() => handleDraftDataRadioSelect(data)} />
                                                                            </div>
                                                                        </td>

                                                                        {hiddenColumns.includes('ssItemDate') && (
                                                                            <td>
                                                                                <DateComp formattedDate={data?.itemDate} />
                                                                            </td>
                                                                        )}
                                                                        {hiddenColumns.includes('ssExpenseCategoryName') && (
                                                                            <td>
                                                                                {data?.expenseCategory?.title}
                                                                            </td>
                                                                        )}
                                                                        {hiddenColumns.includes('ssItemAmount') && (
                                                                            <td className={`text-end pe-4 ${data?.debitOrCreditIndicator === constraintConfig.debitOrCreditIndicator.creditIndicator ? 'text-danger' : null}`}>
                                                                                <CurrencyComp amount={data?.amount} />
                                                                            </td>
                                                                        )}
                                                                        {hiddenColumns.includes('ssVendorName') && (
                                                                            <td>
                                                                                {data?.vendor?.name}
                                                                            </td>
                                                                        )}
                                                                        {hiddenColumns.includes('ssAttachment') && (
                                                                            <td>
                                                                                {data?.attachmentFile === null || data?.attachmentFile === "null" || data?.attachmentFile === "undefined" || data?.attachmentFile === "" ? (
                                                                                    null
                                                                                ) : <FaEye className='ms-10' onClick={() => openPdfInBrowserOrLightbox(data?.attachmentFile)} />}
                                                                            </td>
                                                                        )}
                                                                        {hiddenColumns.includes('ssReportId') && (
                                                                            <td>
                                                                                {data?.trackingId}
                                                                            </td>
                                                                        )}
                                                                        {hiddenColumns.includes('ssPaymentMethod') && (
                                                                            <td>
                                                                                {data?.paymentMethod?.title}
                                                                            </td>
                                                                        )}
                                                                        {hiddenColumns.includes('ssItemDescription') && (
                                                                            <td>
                                                                                <div className='w-200px text-wrap'>
                                                                                    {data && data.itemDetail && <ReactReadMoreReadLess
                                                                                        charLimit={30}
                                                                                        readMoreText={"Read more"}
                                                                                        readLessText={"Read less"}
                                                                                        readMoreClassName="readMore"
                                                                                        readLessClassName="readLess"
                                                                                    >
                                                                                        {data.itemDetail}
                                                                                    </ReactReadMoreReadLess>}
                                                                                </div>
                                                                            </td>
                                                                        )}
                                                                        {hiddenColumns.includes('ssCreatedDate') && (
                                                                            <td><DateComp formattedDate={data?.createdDate} /> </td>
                                                                        )}

                                                                        {hiddenColumns.includes('ssLineItemId') && (
                                                                            <td>{data?.expenseItemId} </td>
                                                                        )}

                                                                        {hiddenColumns.includes('ssSource') && (
                                                                            <td className='ps-5'>
                                                                                <Tooltip id="web-source" place="top" />
                                                                                <Tooltip id="mobile-source" place="top" />
                                                                                <Tooltip id="bank-source" place="top" />
                                                                                <Tooltip id="gorilla-source" place="top" />

                                                                                {data?.recordSourceId === constraintConfig.recordSourceId.WebApp ?
                                                                                    <KTSVG path="/media/icons/figmaIcons/Web.svg" className='svg-icon-1 ms-4'
                                                                                        data-tooltip-id="web-source" data-tooltip-content='Website' />
                                                                                    :
                                                                                    data?.recordSourceId === constraintConfig.recordSourceId.Mobile ?
                                                                                        <KTSVG path="/media/icons/figmaIcons/Mobile.svg" className='svg-icon-1 ms-4'
                                                                                            data-tooltip-id="mobile-source" data-tooltip-content='Mobile' /> :
                                                                                        data?.recordSourceId === constraintConfig.recordSourceId.BankFeed ?
                                                                                            <KTSVG path="/media/icons/figmaIcons/Bank.svg" className='svg-icon-1 ms-4'
                                                                                                data-tooltip-id="bank-source" data-tooltip-content='Bank' />
                                                                                            : data?.recordSourceId === constraintConfig.recordSourceId.GorillaExpense ?
                                                                                                <KTSVG path="/media/icons/figmaIcons/Gorilla.svg" className='svg-icon-1 ms-4'
                                                                                                    data-tooltip-id="gorilla-source" data-tooltip-content='Gorilla Expense' /> : null}
                                                                            </td>
                                                                        )}
                                                                    </>
                                                                    {/* } */}
                                                                </tr>
                                                            ))}
                                                        </>) : (
                                                        <tr>
                                                            <td colSpan={20}>
                                                                <NoRecordFound />
                                                            </td>
                                                        </tr>
                                                    )}
                                                </>}
                                            {ssIsLoading && (
                                                <tr>
                                                    <td colSpan={20} className="text-center">
                                                        <LoadingComponent />
                                                    </td>
                                                </tr>
                                            )}

                                        </tbody>
                                        {/* end::Table body */}
                                    </table>
                                </div>
                                <Pagination
                                    totalResult={ssLineItemData?.result?.totalRecords === 0 ? 0 : ((ssLineItemData?.result?.pageNumber - 1) * ssLineItemData?.result?.pageSize) + 1}
                                    toResult={ssLineItemData?.result?.totalRecords === 0 ? 0 : Math.min(ssLineItemData?.result?.pageNumber * ssLineItemData?.result?.pageSize, ssLineItemData?.result?.totalRecords)}
                                    ofResult={ssLineItemData?.result?.totalRecords}
                                    onChange={handleSSPageSizeChange}
                                    pageSize={ssPageSize}
                                    onPageChange={handleSSPageClick}
                                    pageCount={ssLineItemData?.result?.totalPages || 0}
                                    currentPage={ssPageNumber}
                                />
                            </div>
                        }

                    </div>
                </div>
            </div>
        </>
    )
}

export default MergeLineItems